import * as React from "react";
import { Props } from "../../types/global";
import Img from "../Controls/Img";
import LanguageDetector from '../i18n/language-detector';

const style: React.CSSProperties = {
    width: "100%",
    height: "100%",
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};
export class CreditCardImage extends React.Component<Props> {
    hideMe = () => {
        this.props.ok!();
    }
    render() {
        const language = LanguageDetector.detect();
        if (language && language === "en")
        {
        return (        
            <div style={style} onClick={this.hideMe}>
                <Img style={{ width: 300 }} src="/images/veon/cc-tooltip.png"/>
            </div>
        );
        }
        else {
            return (        
                <div style={style} onClick={this.hideMe}>
                    <Img style={{ width: 300 }} src={`/images/veon/${language}/cc-tooltip.png`}/>
                </div>
            );
        } 
    }
}
